module.exports = __webpack_public_path__ + "img/software_icon6.441ec1e3.png";